/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import axios from 'axios';

/**
 * CustomerReviewIndicator - Shows customer review rating as a clickable star
 * 
 * Props:
 * - phone: string - customer phone number (required)
 * - onReviewsClick: function - called when star is clicked with review data
 */
export default function CustomerReviewIndicator({ phone, onReviewsClick }) {
  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (phone) {
      checkCustomerReviews();
    }
  }, [phone]);

  const checkCustomerReviews = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append('phone', phone);

      const response = await axios.get(`/view-leads/customer-reviews/check?${params}`);
      setReviewData(response.data);
    } catch (error) {
      console.error('Error checking customer reviews:', error);
      setReviewData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleStarClick = () => {
    if (reviewData && reviewData.hasReviews && onReviewsClick) {
      onReviewsClick(reviewData);
    }
  };

  // Don't render if no reviews or still loading
  if (loading || !reviewData || !reviewData.hasReviews) {
    return null;
  }

  return (
    <div 
      className="d-inline-flex align-items-center ms-2"
      style={{ cursor: 'pointer' }}
      onClick={handleStarClick}
      title={`Customer has ${reviewData.totalReviews} review(s) - Average: ${reviewData.averageRating}/5 stars`}
    >
      <FaStar 
        size={20} 
        color="#ffc107" 
        style={{ 
          filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.3))',
          animation: 'pulse 2s infinite'
        }}
      />
      <span 
        className="ms-1 fw-bold text-warning"
        style={{ 
          fontSize: '0.9rem',
          textShadow: '0 1px 2px rgba(0,0,0,0.3)'
        }}
      >
        {reviewData.averageRating}
      </span>
      <style jsx>{`
        @keyframes pulse {
          0%, 100% { 
            transform: scale(1);
            opacity: 1;
          }
          50% { 
            transform: scale(1.1);
            opacity: 0.8;
          }
        }
      `}</style>
    </div>
  );
}
